import { anotherComponentsConfig } from '@efishery/components';
import { defineStyle, defineStyleConfig, createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { checkboxAnatomy, radioAnatomy } from '@chakra-ui/anatomy';

var colors = {
    //
    brand: {
        50: "rgb(243,249,247)",
        70: "rgb(228,244,241)",
        100: "rgb(205,231,225)",
        200: "rgb(154,207,194)",
        300: "rgb(104,183,164)",
        400: "rgb(53,159,133)",
        500: "rgb(3,135,103)",
        600: "rgb(2,108,82)",
        700: "rgb(2,81,62)",
        800: "rgb(1,55,42)",
        900: "rgb(1,40,31)"
    },
    //
    observatory: {
        50: "rgb(243,249,247)",
        70: "rgb(228,244,241)",
        100: "rgb(205,231,225)",
        200: "rgb(154,207,194)",
        300: "rgb(104,183,164)",
        400: "rgb(53,159,133)",
        500: "rgb(3,135,103)",
        600: "rgb(2,108,82)",
        700: "rgb(2,81,62)",
        800: "rgb(1,55,42)",
        900: "rgb(1,40,31)"
    },
    //
    primary: {
        50: "rgb(243,249,247)",
        70: "rgb(228,244,241)",
        100: "rgb(205,231,225)",
        200: "rgb(154,207,194)",
        300: "rgb(104,183,164)",
        400: "rgb(53,159,133)",
        500: "rgb(3,135,103)",
        600: "rgb(2,108,82)",
        700: "rgb(2,81,62)",
        800: "rgb(1,55,42)",
        900: "rgb(1,40,31)"
    },
    //
    aqua: {
        50: "rgb(236,253,245)",
        70: "rgb(223,252,237)",
        100: "rgb(209,250,229)",
        200: "rgb(167,243,208)",
        300: "rgb(110,231,183)",
        400: "rgb(52,211,153)",
        500: "rgb(16,185,129)",
        600: "rgb(5,150,105)",
        700: "rgb(4,120,87)",
        800: "rgb(6,95,70)",
        900: "rgb(6,78,59)"
    },
    //
    teal: {
        50: "rgb(240,253,250)",
        70: "rgb(225,250,245)",
        100: "rgb(211,247,240)",
        200: "rgb(153,246,228)",
        300: "rgb(94,234,212)",
        400: "rgb(45,212,191)",
        500: "rgb(20,184,166)",
        600: "rgb(13,148,136)",
        700: "rgb(15,118,110)",
        800: "rgb(17,94,89)",
        900: "rgb(19,78,74)"
    },
    //
    lightBlue: {
        50: "rgb(240,249,255)",
        70: "rgb(234,246,255)",
        100: "rgb(224,242,254)",
        200: "rgb(186,230,253)",
        300: "rgb(125,211,252)",
        400: "rgb(56,189,248)",
        500: "rgb(14,165,233)",
        600: "rgb(2,132,199)",
        700: "rgb(3,105,161)",
        800: "rgb(7,89,133)",
        900: "rgb(12,74,110)"
    },
    //
    lime: {
        50: "rgb(247,254,231)",
        70: "rgb(242,253,219)",
        100: "rgb(205,231,225)",
        200: "rgb(236,252,203)",
        300: "rgb(190,242,100)",
        400: "rgb(163,230,53)",
        500: "rgb(132,204,22)",
        600: "rgb(101,163,13)",
        700: "rgb(77,124,15)",
        800: "rgb(63,98,18)",
        900: "rgb(54,83,20)"
    },
    //
    purple: {
        50: "rgb(250,245,255)",
        70: "rgb(247,239,255)",
        100: "rgb(243,232,255)",
        200: "rgb(233,213,255)",
        300: "rgb(216,180,254)",
        400: "rgb(192,132,252)",
        500: "rgb(168,85,247)",
        600: "rgb(147,51,234)",
        700: "rgb(126,34,206)",
        800: "rgb(107,33,168)",
        900: "rgb(88,28,135)"
    },
    //
    pink: {
        50: "rgb(253,242,248)",
        70: "rgb(253,239,247)",
        100: "rgb(252,231,243)",
        200: "rgb(251,207,232)",
        300: "rgb(249,168,212)",
        400: "rgb(244,114,182)",
        500: "rgb(236,72,153)",
        600: "rgb(219,39,119)",
        700: "rgb(190,24,93)",
        800: "rgb(157,23,77)",
        900: "rgb(131,24,67)"
    },
    //
    green: {
        50: "rgb(236,253,245)",
        70: "rgb(223,252,237)",
        100: "rgb(209,250,229)",
        200: "rgb(167,243,208)",
        300: "rgb(110,231,183)",
        400: "rgb(52,211,153)",
        500: "rgb(16,185,129)",
        600: "rgb(5,150,105)",
        700: "rgb(4,120,87)",
        800: "rgb(6,95,70)",
        900: "rgb(6,78,59)"
    },
    //
    freshGreen: {
        50: "rgb(247,254,231)",
        70: "rgb(242,253,219)",
        100: "rgb(205,231,225)",
        200: "rgb(236,252,203)",
        300: "rgb(190,242,100)",
        400: "rgb(163,230,53)",
        500: "rgb(132,204,22)",
        600: "rgb(101,163,13)",
        700: "rgb(77,124,15)",
        800: "rgb(63,98,18)",
        900: "rgb(54,83,20)"
    },
    //
    blue: {
        50: "rgb(239,246,255)",
        70: "rgb(230,241,255)",
        100: "rgb(219,234,254)",
        200: "rgb(191,219,254)",
        300: "rgb(147,197,253)",
        400: "rgb(96,165,250)",
        500: "rgb(59,130,246)",
        600: "rgb(37,99,235)",
        700: "rgb(29,78,216)",
        800: "rgb(30,64,175)",
        900: "rgb(30,58,138)"
    },
    //
    red: {
        50: "rgb(255,241,242)",
        70: "rgb(255,237,238)",
        100: "rgb(255,228,230)",
        200: "rgb(254,205,211)",
        300: "rgb(253,164,175)",
        400: "rgb(251,113,133)",
        500: "rgb(244,63,94)",
        600: "rgb(225,29,72)",
        700: "rgb(190,18,60)",
        800: "rgb(159,18,57)",
        900: "rgb(136,19,55)"
    },
    //
    orange: {
        50: "rgb(255,249,245)",
        70: "rgb(254,240,229)",
        100: "rgb(253,233,217)",
        200: "rgb(251,212,179)",
        300: "rgb(248,190,142)",
        400: "rgb(244,147,66)",
        500: "rgb(192,87,23)",
        600: "rgb(158,67,11)",
        700: "rgb(118,50,8)",
        800: "rgb(84,33,3)",
        900: "rgb(51,17,2)"
    },
    //
    yellow: {
        50: "rgb(255,251,235)",
        70: "rgb(255,247,216)",
        100: "rgb(254,243,199)",
        200: "rgb(253,230,138)",
        300: "rgb(252,211,77)",
        400: "rgb(251,191,36)",
        500: "rgb(245,158,11)",
        600: "rgb(217,119,6)",
        700: "rgb(180,83,9)",
        800: "rgb(146,64,14)",
        900: "rgb(120,53,15)"
    },
    black: {
        50: "rgb(246, 246, 246)",
        70: "rgb(224, 224, 224)",
        100: "rgb(210, 210, 210)",
        200: "rgb(165, 165, 165)",
        300: "rgb(119, 119, 119)",
        400: "rgb(74, 74, 74)",
        500: "rgb(29, 29, 29)",
        600: "rgb(23, 23, 23)",
        700: "rgb(17, 17, 17)",
        800: "rgb(14, 14, 14)",
        900: "rgb(13, 13, 13)"
    },
    grey: {
        50: "rgb(250,250,250)",
        70: "rgb(245,245,245)",
        100: "rgb(239,239,239)",
        200: "rgb(229,229,229)",
        300: "rgb(212,212,212)",
        400: "rgb(163,163,163)",
        500: "rgb(115,115,115)",
        600: "rgb(82,82,82)",
        700: "rgb(64,64,64)",
        800: "rgb(38,38,38)",
        900: "rgb(23,23,23)"
    }
};

var base = 0.0625;
var getRemSizeByPx = function(entry) {
    return String(base * entry) + "rem";
};

var fontSizes = {
    "2xs": getRemSizeByPx(11),
    xs: getRemSizeByPx(12),
    sm: getRemSizeByPx(14),
    md: getRemSizeByPx(15),
    lg: getRemSizeByPx(16),
    xl: getRemSizeByPx(18),
    "2xl": getRemSizeByPx(20),
    "3xl": getRemSizeByPx(22),
    "4xl": getRemSizeByPx(24),
    "5xl": getRemSizeByPx(26),
    "6xl": getRemSizeByPx(28),
    "7xl": getRemSizeByPx(30),
    "8xl": getRemSizeByPx(32),
    "9xl": getRemSizeByPx(34),
    "11": getRemSizeByPx(11),
    "12": getRemSizeByPx(12),
    "14": getRemSizeByPx(14),
    "15": getRemSizeByPx(15),
    "16": getRemSizeByPx(16),
    "18": getRemSizeByPx(18),
    "20": getRemSizeByPx(20)
};
var lineHeights = {
    normal: "normal",
    none: "1",
    shorter: "1.25",
    short: "1.375",
    base: "1.6",
    tall: "1.725",
    taller: "2",
    "3": ".75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem"
};
var letterSpacings = {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0.5px",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
};

var isBrand = function(colorScheme) {
    return [
        "brand",
        "primary",
        "observatory"
    ].includes(colorScheme);
};
var baseStyle$2 = defineStyle({
    rounded: "lg",
    paddingStart: "5",
    paddingInlineStart: "5",
    paddingEnd: "5",
    paddingInlineEnd: "5",
    letterSpacing: "normal",
    _disabled: {
        opacity: 1
    }
});
var primaryVariant = defineStyle(function(options) {
    var disabledStyle = {
        backgroundColor: "grey.200",
        color: "grey.500",
        boxShadow: "inset 0px -2px 0px rgba(0, 0, 0, 0.25)"
    };
    return {
        boxShadow: "inset 0px -2px 0px rgba(0, 0, 0, 0.25)",
        backgroundColor: isBrand(options.colorScheme) ? "".concat(options.colorScheme, ".500") : "".concat(options.colorScheme, ".600"),
        color: "white",
        _focus: {
            boxShadow: "0px 0px 0px 3px ".concat(options.theme.__cssVars["--chakra-colors-".concat(options.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"), ", inset 0px -2px 0px rgba(0, 0, 0, 0.25)")
        },
        _hover: {
            backgroundColor: isBrand(options.colorScheme) ? "".concat(options.colorScheme, ".400") : "".concat(options.colorScheme, ".500"),
            boxShadow: "inset 0px -2px 0px rgba(0, 0, 0, 0.25)",
            _disabled: disabledStyle
        },
        _disabled: disabledStyle,
        _active: {
            transition: "".concat(options.theme.transition.property.background, " ").concat(options.theme.transition.duration.slow, " ").concat(options.theme.transition.easing["ease-in-out"]),
            backgroundColor: isBrand(options.colorScheme) ? "".concat(options.colorScheme, ".600") : "".concat(options.colorScheme, ".700")
        },
        _pressed: {
            backgroundColor: isBrand(options.colorScheme) ? "".concat(options.colorScheme, ".600") : "".concat(options.colorScheme, ".700")
        }
    };
});
var secondaryVariant = defineStyle(function(options) {
    var disabledStyle = {
        backgroundColor: "grey.50",
        color: "grey.400"
    };
    return {
        backgroundColor: "".concat(options.colorScheme, ".50"),
        color: "".concat(options.colorScheme, ".500"),
        _focus: {
            backgroundColor: "".concat(options.colorScheme, ".50"),
            boxShadow: "0px 0px 0px 3px ".concat(options.theme.__cssVars["--chakra-colors-".concat(options.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"))
        },
        _hover: {
            backgroundColor: "".concat(options.colorScheme, ".70"),
            _disabled: disabledStyle
        },
        _disabled: disabledStyle,
        _active: {
            transition: "".concat(options.theme.transition.property.background, " ").concat(options.theme.transition.duration.slow, " ").concat(options.theme.transition.easing["ease-in-out"]),
            backgroundColor: "".concat(options.colorScheme, ".100")
        },
        _pressed: {
            backgroundColor: "".concat(options.colorScheme, ".100")
        }
    };
});
var tertiaryVariant = defineStyle(function(options) {
    return {
        color: isBrand(options.colorScheme) ? "".concat(options.colorScheme, ".500") : "".concat(options.colorScheme, ".600"),
        border: "1px",
        borderStyle: "solid",
        borderColor: "grey.200",
        _focus: {
            border: "1px",
            borderStyle: "solid",
            borderColor: "grey.100",
            boxShadow: "none"
        },
        _hover: {
            border: "1px",
            borderStyle: "solid",
            borderColor: "grey.100",
            backgroundColor: "initial"
        },
        _disabled: {
            border: "1px",
            borderStyle: "solid",
            borderColor: "grey.200",
            color: "grey.400"
        },
        _active: {
            transition: "".concat(options.theme.transition.property.background, " ").concat(options.theme.transition.duration.slow, " ").concat(options.theme.transition.easing["ease-in-out"]),
            backgroundColor: "grey.50"
        },
        _pressed: {
            backgroundColor: "grey.50"
        }
    };
});
var outlineVariant = defineStyle(function(options) {
    var disabledStyle = {
        border: "1px",
        borderStyle: "solid",
        borderColor: "grey.100",
        color: "grey.400"
    };
    return {
        color: "".concat(options.colorScheme, ".500"),
        border: "1px",
        borderStyle: "solid",
        borderColor: "".concat(options.colorScheme, ".500"),
        _focus: {
            border: "1px",
            borderStyle: "solid",
            borderColor: "".concat(options.colorScheme, ".500"),
            boxShadow: "none"
        },
        _hover: {
            border: "1px",
            borderStyle: "solid",
            borderColor: "".concat(options.colorScheme, ".500"),
            backgroundColor: "".concat(options.colorScheme, ".50"),
            _disabled: disabledStyle
        },
        _disabled: disabledStyle,
        _active: {
            transition: "".concat(options.theme.transition.property.background, " ").concat(options.theme.transition.duration.slow, " ").concat(options.theme.transition.easing["ease-in-out"]),
            backgroundColor: "grey.50"
        },
        _pressed: {
            backgroundColor: "grey.50"
        }
    };
});
var linkVariant = defineStyle({
    _disabled: {
        color: "grey.400"
    }
});
var variants = {
    solid: primaryVariant,
    primary: primaryVariant,
    secondary: secondaryVariant,
    ghost: tertiaryVariant,
    tertiary: tertiaryVariant,
    outline: outlineVariant,
    link: linkVariant
};
var Button = defineStyleConfig({
    baseStyle: baseStyle$2,
    variants: variants,
    defaultProps: {
        colorScheme: "brand"
    }
});

var ref$1 = createMultiStyleConfigHelpers(checkboxAnatomy.keys), definePartsStyle$1 = ref$1.definePartsStyle, defineMultiStyleConfig$1 = ref$1.defineMultiStyleConfig;
var baseStyleControl$1 = defineStyle(function(props) {
    return {
        backgroundColor: "white",
        borderRadius: "4px",
        borderColor: "black.200",
        _hover: {
            borderColor: "brand.300",
            _disabled: {
                borderColor: "black.70"
            }
        },
        _checked: {
            _hover: {
                backgroundColor: "".concat(props.colorScheme, ".500"),
                boxShadow: "0px 0px 0px 2px ".concat(props.theme.__cssVars["--chakra-colors-".concat(props.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"), ", inset 0px -2px 0px rgba(0, 0, 0, 0.25)"),
                border: 0
            },
            _disabled: {
                backgroundColor: "black.70",
                borderColor: "black.70",
                color: "white",
                boxShadow: "none"
            }
        },
        _indeterminate: {
            _hover: {
                backgroundColor: "".concat(props.colorScheme, ".500"),
                boxShadow: "0px 0px 0px 2px ".concat(props.theme.__cssVars["--chakra-colors-".concat(props.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"), ", inset 0px -2px 0px rgba(0, 0, 0, 0.25)"),
                border: 0
            },
            _disabled: {
                backgroundColor: "black.70",
                borderColor: "black.70",
                color: "white",
                boxShadow: "none"
            }
        },
        _disabled: {
            backgroundColor: "inherit",
            borderColor: "black.70"
        },
        _invalid: {
            borderColor: "red.600"
        }
    };
});
var baseStyle$1 = definePartsStyle$1(function(props) {
    return {
        control: baseStyleControl$1(props)
    };
});
var Checkbox = defineMultiStyleConfig$1({
    baseStyle: baseStyle$1,
    defaultProps: {
        size: "md",
        colorScheme: "brand"
    }
});

function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ref = createMultiStyleConfigHelpers(radioAnatomy.keys), definePartsStyle = ref.definePartsStyle, defineMultiStyleConfig = ref.defineMultiStyleConfig;
var baseStyleControl = defineStyle(function(props) {
    var ref;
    var controlStyle = (ref = Checkbox.baseStyle) === null || ref === void 0 ? void 0 : ref.call(Checkbox, props).control;
    return _objectSpreadProps$1(_objectSpread$2({}, controlStyle), {
        borderRadius: "full",
        _checked: {
            backgroundColor: "white",
            _hover: {
                backgroundColor: "white",
                boxShadow: "0px 0px 0px 2px ".concat(props.theme.__cssVars["--chakra-colors-".concat(props.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"), ", inset 0px 0px 0px rgba(0, 0, 0, 0.25)")
            },
            _disabled: {
                backgroundColor: "white",
                boxShadow: "none",
                _before: {
                    backgroundColor: "black.70"
                }
            },
            _before: {
                content: '""',
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "".concat(props.colorScheme, ".500")
            }
        }
    });
});
var baseStyle = definePartsStyle(function(props) {
    return {
        control: baseStyleControl(props)
    };
});
var Radio = defineMultiStyleConfig({
    baseStyle: baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "brand"
    }
});

var input = {
    Input: {
        defaultProps: {
            colorScheme: "brand"
        },
        variants: {
            outline: function(options) {
                return {
                    field: {
                        backgroundColor: "white",
                        borderColor: "grey.200",
                        rounded: "lg",
                        _placeholder: {
                            color: "grey.400"
                        },
                        _disabled: {
                            backgroundColor: "grey.200",
                            color: "grey.400"
                        },
                        _hover: {
                            borderColor: "black.500"
                        },
                        _focus: {
                            borderColor: "".concat(options.colorScheme, ".500"),
                            boxShadow: "0px 0px 0px 3px ".concat(options.theme.__cssVars["--chakra-colors-".concat(options.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"))
                        }
                    }
                };
            }
        }
    },
    Textarea: {
        defaultProps: {
            colorScheme: "brand"
        },
        variants: {
            outline: function(options) {
                return {
                    backgroundColor: "white",
                    borderColor: "grey.200",
                    rounded: "lg",
                    _placeholder: {
                        color: "grey.400"
                    },
                    _disabled: {
                        backgroundColor: "grey.200",
                        color: "grey.400"
                    },
                    _hover: {
                        borderColor: "black.500"
                    },
                    _focus: {
                        borderColor: "".concat(options.colorScheme, ".500"),
                        boxShadow: "0px 0px 0px 3px ".concat(options.theme.__cssVars["--chakra-colors-".concat(options.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"))
                    }
                };
            }
        }
    },
    Select: {
        defaultProps: {
            colorScheme: "brand"
        },
        variants: {
            outline: function(options) {
                return {
                    field: {
                        backgroundColor: "white",
                        borderColor: "grey.200",
                        rounded: "lg",
                        _placeholder: {
                            color: "grey.400"
                        },
                        _disabled: {
                            backgroundColor: "grey.200",
                            color: "grey.400"
                        },
                        _hover: {
                            borderColor: "black.500"
                        },
                        _focus: {
                            borderColor: "".concat(options.colorScheme, ".500"),
                            boxShadow: "0px 0px 0px 3px ".concat(options.theme.__cssVars["--chakra-colors-".concat(options.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"))
                        }
                    }
                };
            }
        }
    },
    NumberInput: {
        defaultProps: {
            colorScheme: "brand"
        },
        variants: {
            outline: function(options) {
                return {
                    field: {
                        backgroundColor: "white",
                        borderColor: "grey.200",
                        rounded: "lg",
                        _placeholder: {
                            color: "grey.400"
                        },
                        _disabled: {
                            backgroundColor: "grey.200",
                            color: "grey.400"
                        },
                        _hover: {
                            borderColor: "black.500"
                        },
                        _focus: {
                            borderColor: "".concat(options.colorScheme, ".500"),
                            boxShadow: "0px 0px 0px 3px ".concat(options.theme.__cssVars["--chakra-colors-".concat(options.colorScheme, "-500")].replace("rgb", "rgba").replace(")", ", 0.2)"))
                        }
                    }
                };
            }
        }
    }
};

var badge = {
    baseStyle: {
        rounded: "full",
        paddingStart: "2",
        paddingInlineStart: "2",
        paddingEnd: "2",
        paddingInlineEnd: "2",
        letterSpacing: "normal",
        textTransform: "none"
    }
};

var progress = {
    Progress: {
        defaultProps: {
            colorScheme: "brand",
            variant: "default",
            size: "xs" // === '4px' || '0.25rem'
        }
    }
};

var circularProgress = {
    baseStyle: {
        size: "md",
        color: "brand.500"
    }
};

var heading = {
    Heading: {
        sizes: {
            "16": {
                fontSize: "16",
                lineHeight: "5"
            },
            "18": {
                fontSize: "18",
                lineHeight: "6"
            },
            "20": {
                fontSize: "20",
                lineHeight: "6"
            },
            "2xl": function() {
                return {
                    lineHeight: 2
                };
            }
        }
    }
};

var text = {
    sizes: {
        "11": {
            fontSize: "11",
            lineHeight: "3"
        },
        "12": {
            fontSize: "12",
            lineHeight: "3"
        },
        "14": {
            fontSize: "14",
            lineHeight: "5"
        },
        "15": {
            fontSize: "15",
            lineHeight: "5"
        },
        "16": {
            fontSize: "16",
            lineHeight: "5"
        }
    }
};

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var components = _objectSpreadProps(_objectSpread$1(_objectSpreadProps(_objectSpread$1(_objectSpreadProps(_objectSpread$1({
    Button: Button,
    Checkbox: Checkbox,
    Radio: Radio
}, input), {
    Badge: badge
}), progress), {
    CircularProgress: circularProgress
}), heading), {
    Text: text
});

var elevations = {
    "4sm": "0px 2px 4px rgba(0, 0, 0, 0.08)",
    "4md": "0px 2px 4px rgba(0, 0, 0, 0.16)",
    "4lg": "0px 2px 4px rgba(0, 0, 0, 0.24)",
    "8sm": "0px 2px 8px rgba(0, 0, 0, 0.08)",
    "8md": "0px 2px 8px rgba(0, 0, 0, 0.16)",
    "8lg": "0px 2px 8px rgba(0, 0, 0, 0.24)"
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var theme = {
    styles: {
        global: {
            body: {
                fontFamily: "'Inter', 'poppins', Helvetica Neue, Roboto",
                letterSpacing: "0.5px"
            }
        }
    },
    components: _objectSpread({}, components, anotherComponentsConfig),
    colors: colors,
    fontSizes: fontSizes,
    lineHeights: lineHeights,
    letterSpacings: letterSpacings,
    shadow: elevations
};

export { theme };
